<ng-container>
  <table class="col-md-12">
    <tr class="float-left mr bold">
      {{'testId.TabItems.itemGroupList.heading' | translate}}
    <tr>
    <tr>
      <td class="float-left">
        <button mat-flat-button color="warn" class="btn-warn" (click)="gotoItems()">
          <span>{{'testId.TabItems.itemGroupList.btnBack' | translate}}</span>
        </button>
      </td>
      <td class="float-right">
        <button mat-flat-button color="warn" class="btn-warn" (click)="createItemGroupDialog()">
          <span>+ {{'testId.TabItems.itemGroupList.btnNew' | translate}}</span>
        </button>
      </td>
    </tr>
  </table>

  <div class="row">
    <div class="col-md-12">
      <div class="table-container" *ngIf="!isNoItemGroup">
        <table mat-table matSortb #table class="mat-elevation-z8" [dataSource]="itemGroupList" cdkDropList
          [cdkDropListData]="itemGroupList" *ngIf="!isNoItemGroup"
          (cdkDropListDropped)="dragAndDropEventHandler($event)">
          <ng-container matColumnDef="itemGroups">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.itemGroupList.column1' | translate}}
            </th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row?.itemGroupName?.length > 40 then sliceTitle else noSliceTitle">
              </ng-container>

              <ng-template #sliceTitle>
                <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.itemGroupName}}"
                  matTooltipPosition="above">
                  {{row?.itemGroupName | slice: 0:40}}...</div>
              </ng-template>
              <ng-template #noSliceTitle>
                <div class="text-bold">{{row?.itemGroupName }}</div>
              </ng-template>

              <ng-container
                *ngIf="row?.itemGroupDescription?.length > 40 then sliceDescription else noSliceDescription">
              </ng-container>
              <ng-template #sliceDescription>
                <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.itemGroupDescription}}"
                  matTooltipPosition="above" class="description-text">
                  {{row?.itemGroupDescription | slice: 0:40}}...</div>
              </ng-template>
              <ng-template #noSliceDescription>
                <div class="description-text">{{row?.itemGroupDescription }}</div>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="scoringType">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="col-w">
              {{'testId.TabItems.itemGroupList.column2' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              {{row.scoringTypeId == 1 ? ('items.questionScoring' | translate) : row.scoringTypeId == 3 ? ('items.DICSStyle' | translate) :
              ('items.optionScoring' | translate)}}
              <!-- {{row.scoringTypeId == 1 ? ScoringTypeNameEnum.OnQuestion : row.scoringTypeId == 3 ? ScoringTypeNameEnum.On180360Degree : ScoringTypeNameEnum.OnOption}} -->
            </td>
          </ng-container>
          <ng-container matColumnDef="updated">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="col-w">
              {{'testId.TabItems.itemGroupList.column3' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <div class="text-bold">{{row.updatedBy}}</div>
              <div>{{row.updated | dateAgo}}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabItems.itemGroupList.column4' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="editItemGroup(row)"
                matTooltip="{{'testId.TabItems.itemGroupList.toolTip.edit' | translate}}">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="deleteItemGroup(row)"
                [ngClass]="{disableIcon : (roleSer.accessData?!roleSer.accessData.deleteAllowed :true)}"
                matTooltip="{{'testId.TabItems.itemGroupList.toolTip.delete' | translate}}">
                <mat-icon>delete_outline</mat-icon>
              </button>


              <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editItemGroup(row)">
                  <mat-icon>edit</mat-icon>
                  <span>{{'testId.TabItems.itemGroupList.toolTip.edit' | translate}}</span>
                </button>
                <button mat-menu-item (click)="deleteItemGroup(row)"
                [disabled]="(roleSer.accessData?!roleSer.accessData.deleteAllowed :true)">
                  <mat-icon>delete_outline</mat-icon>
                  <span>{{'testId.TabItems.itemGroupList.toolTip.delete' | translate}}</span>
                </button>
              </mat-menu> -->
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row">
            <div class="drag-box" *cdkDragPreview>
              {{row.itemGroupName}}
            </div>
          </tr>
        </table>
      </div>
      <div class="item-group-paginator" [ngClass]="{'hidden': showPaginator === false}" *ngIf="!isNoItemGroup">
        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons
          (page)="onPageChange($event)"></mat-paginator>
      </div>
      <br>
      <div class="no-records-found" *ngIf="isNoItemGroup">
        {{'testId.TabItems.itemGroupList.errorMsg' | translate}}
      </div>
    </div>
  </div>
</ng-container>
<ng-template #addItemGroups></ng-template>
<app-create-item-group #addItemGroup [testUUID]="testUUID"
  (itemGroupListData)="itemGroupsList($event)"></app-create-item-group>
